import { Component, OnInit, signal, ViewChild } from "@angular/core";

import { AbcCore } from "@barthauer/abc/core";
import { RouterModule } from "@angular/router";

import {
  Email,
  IUserInfo,
  NotificationMessage,
  Person,
  ToastType,
} from "@barthauer/custom/xmt-models";
import { first, Observable, of, switchMap } from "rxjs";
import { DataService } from "../services/data.service";
import { NotificationService } from "../services/notification.service";
import {
  _AbcButtonComponent,
  _AbcFormComponent,
  AbcTextBoxComponent,
} from "@barthauer/abc/ui-components";
import { LandingPageService } from "../shared/landing-page/landing-page.service";
import { forgotPasswordTemplate } from "../../../assets/templates/email-templates/forgot-password-template";
import { environment } from "../../../environments/environment";
import { ConfigService } from "libs/abc/core/configuration/src/lib/services/config.service";
import { EmailService } from "../services/email.service";
import { IExtensionService } from "../models/interfaces.model";
import { DxValidatorModule } from "devextreme-angular";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
  imports: [
    AbcTextBoxComponent,
    _AbcButtonComponent,
    RouterModule,
    DxValidatorModule,
  ],
})
export class ForgotPasswordComponent implements OnInit {
  @ViewChild("emailTextBox", { static: true })
  emailTextBox: AbcTextBoxComponent;

  protected user: Person;
  protected isSuccess = signal(false);
  protected isValidEmail = signal(false);
  protected resetEmail: string = "";
  private readonly currentConfigurationUrl: string;
  protected translator = this.dataService.res;

  constructor(
    private abcCore: AbcCore,
    public dataService: DataService,
    private landingPageService: LandingPageService,
    private notificationService: NotificationService,
    private configService: ConfigService,
    private emailService: EmailService,
  ) {
    this.currentConfigurationUrl =
      configService.getConfiguration().WebApi.BaseURL;
  }

  ngOnInit(): void {}

  protected updateField() {
    const emailRegex = /^[\d\w._-]+@[\d\w._-]+\.[\w]+$/i;
    this.isValidEmail.set(emailRegex.test(this.resetEmail));
  }

  protected submitResetEmail() {
    const userInfo: IUserInfo = {
      Email: this.resetEmail,
    };
    this.landingPageService
      .getUserLogin(userInfo)
      .pipe(
        first(),
        switchMap((userFound) => {
          const user = userFound as unknown as IExtensionService<Person>;
          if (user.Data) {
            return this.sendEmailInvitation(user.Data);
          } else {
            return of(null);
          }
        }),
      )
      .subscribe({
        next: (result) => {
          this.isSuccess.set(true);
        },
        error: (error) => {
          this.abcCore.error.publish(error);
          this.notificationService.callNotification({
            message: NotificationMessage.ErrorGeneral,
            type: ToastType.ERROR,
          });
        },
      });
  }

  private sendEmailInvitation(user: Person): Observable<ArrayBuffer> {
    const toDayDate = new Date().getTime();
    const landingPageUrl = `${this.currentConfigurationUrl}/aims/reset-password/${btoa(user.Id + "&&&" + toDayDate)}`;
    const logoUrl =
      this.dataService.currentCongfiguration.WebApi.BaseURL +
      "/aims/assets/images/aims-logo.png";

    const emailContent = {
      logoUrl: logoUrl,
      person: {
        FirstName: user.FirstName,
        LastName: user.LastName,
        username: user.Login,
      },
      landingPageUrl: landingPageUrl,
    };
    const emailBody = this.emailService.prepareEmailBody(
      forgotPasswordTemplate,
      emailContent,
    );
    const email: Email = {
      Subject: this.translator("user-emailSubject"),
      Body: emailBody,
      From: environment.Email.systemEmail,
      To: this.resetEmail,
    };
    return this.emailService.sendEmail(email, true);
  }
}
